import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Получаем сохраненную тему из localStorage или используем светлую по умолчанию
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  // Применяем тему к документу только при изменении
  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = React.useCallback(() => {
    // Добавляем анимацию переключения
    document.body.classList.add('theme-switching');
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    
    // Сохраняем в localStorage только при переключении
    localStorage.setItem('theme', newTheme);
    
    // Убираем класс анимации после завершения
    setTimeout(() => {
      document.body.classList.remove('theme-switching');
    }, 300);
  }, [theme]);

  const value = React.useMemo(() => ({
    theme,
    toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light'
  }), [theme, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
